import React, { useRef, useState, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

const MusicPlayer = ({ autoPlay, onTimeUpdate }) => {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (autoPlay && audioRef.current) {
      audioRef.current.volume = 0.6;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  }, [autoPlay]);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { audioRef.current.play(); setPlaying(true); }
  };

  const handleTimeUpdate = () => {
    if (onTimeUpdate && audioRef.current) onTimeUpdate(audioRef.current.currentTime);
  };

  return (
    <>
      <audio
        ref={audioRef}
        src={process.env.PUBLIC_URL + '/music/music.webm'}
        onTimeUpdate={handleTimeUpdate}
        onError={(e) => {
          if (e.target.src.includes('soundhelix')) return;
          e.target.src = "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3";
        }}
        loop
      />
      <div className="music-player vibe-player pop-card" onClick={toggle}>
        {playing ? <Volume2 size={20} color="#000" /> : <VolumeX size={20} color="#000" />}
        <span style={{ fontWeight: 800, color: '#000', fontSize: '0.85rem' }}>{playing ? 'ROASTING...' : 'MUTED'}</span>
        {playing && (
          <div className="vibe-bars">
            <span /><span /><span />
          </div>
        )}
      </div>
    </>
  );
};

export default MusicPlayer;
